import {
  toCharArray32huqyw9tt7kx as toCharArray,
  decodeToString1x4faah2liw2p as decodeToString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { createThis2j2avj17cvnv2 as createThis } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  copyOfRange3alro60z4hhf8 as copyOfRange,
  contentEquals1cdp6c846cfdi as contentEquals,
  contentHashCode25jw6rgkgywwr as contentHashCode,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  _UByte___init__impl__g9hnc418b8pq346rvu4 as _UByte___init__impl__g9hnc4,
  _UByte___get_data__impl__jof9qrfg5oujomrowy as _UByte___get_data__impl__jof9qr,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.i4e_1 = ByteString().m4e(new Int8Array(0), null);
        this.j4e_1 = toCharArray('0123456789abcdef');
      }
      n4e(byteArray) {
        return ByteString().m4e(byteArray, null);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var ByteStringClass;
function ByteString() {
  if (ByteStringClass === VOID) {
    class $ {
      static m4e(data, dummy) {
        Companion_getInstance();
        var $this = createThis(this);
        $this.k4e_1 = data;
        $this.l4e_1 = 0;
        return $this;
      }
      static o4e(data, startIndex, endIndex) {
        Companion_getInstance();
        startIndex = startIndex === VOID ? 0 : startIndex;
        endIndex = endIndex === VOID ? data.length : endIndex;
        return this.m4e(copyOfRange(data, startIndex, endIndex), null);
      }
      v2() {
        return this.k4e_1.length;
      }
      equals(other) {
        if (this === other)
          return true;
        if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
          return false;
        if (!(other instanceof ByteString()))
          THROW_CCE();
        if (!(other.k4e_1.length === this.k4e_1.length))
          return false;
        if (!(other.l4e_1 === 0) && !(this.l4e_1 === 0) && !(other.l4e_1 === this.l4e_1))
          return false;
        return contentEquals(this.k4e_1, other.k4e_1);
      }
      hashCode() {
        var hc = this.l4e_1;
        if (hc === 0) {
          hc = contentHashCode(this.k4e_1);
          this.l4e_1 = hc;
        }
        return hc;
      }
      w2(index) {
        if (index < 0 || index >= this.v2())
          throw IndexOutOfBoundsException().n3('index (' + index + ') is out of byte string bounds: [0..' + this.v2() + ')');
        return this.k4e_1[index];
      }
      h2x(startIndex, endIndex) {
        var tmp;
        if (startIndex === endIndex) {
          tmp = Companion_getInstance().i4e_1;
        } else {
          tmp = ByteString().o4e(this.k4e_1, startIndex, endIndex);
        }
        return tmp;
      }
      p4e(startIndex, endIndex, $super) {
        endIndex = endIndex === VOID ? this.v2() : endIndex;
        return $super === VOID ? this.h2x(startIndex, endIndex) : $super.h2x.call(this, startIndex, endIndex);
      }
      q4e(other) {
        if (other === this)
          return 0;
        var localData = this.k4e_1;
        var otherData = other.k4e_1;
        var inductionVariable = 0;
        var tmp0 = this.v2();
        // Inline function 'kotlin.math.min' call
        var b = other.v2();
        var last = Math.min(tmp0, b);
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.toUByte' call
            var this_0 = localData[i];
            var tmp0_0 = _UByte___init__impl__g9hnc4(this_0);
            // Inline function 'kotlin.toUByte' call
            var this_1 = otherData[i];
            // Inline function 'kotlin.UByte.compareTo' call
            var other_0 = _UByte___init__impl__g9hnc4(this_1);
            // Inline function 'kotlin.UByte.toInt' call
            var tmp = _UByte___get_data__impl__jof9qr(tmp0_0) & 255;
            // Inline function 'kotlin.UByte.toInt' call
            var tmp$ret$4 = _UByte___get_data__impl__jof9qr(other_0) & 255;
            var cmp = compareTo(tmp, tmp$ret$4);
            if (!(cmp === 0))
              return cmp;
          }
           while (inductionVariable < last);
        return compareTo(this.v2(), other.v2());
      }
      d(other) {
        return this.q4e(other instanceof ByteString() ? other : THROW_CCE());
      }
      toString() {
        if (isEmpty(this)) {
          return 'ByteString(size=0)';
        }
        var sizeStr = this.v2().toString();
        var len = (22 + sizeStr.length | 0) + imul(this.v2(), 2) | 0;
        // Inline function 'kotlin.with' call
        var $this$with = StringBuilder().yb(len);
        $this$with.r1('ByteString(size=');
        $this$with.r1(sizeStr);
        $this$with.r1(' hex=');
        var localData = this.k4e_1;
        var inductionVariable = 0;
        var last = this.v2();
        if (inductionVariable < last)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var b = localData[i];
            $this$with.t1(Companion_getInstance().j4e_1[(b >>> 4 | 0) & 15]);
            $this$with.t1(Companion_getInstance().j4e_1[b & 15]);
          }
           while (inductionVariable < last);
        return $this$with.t1(_Char___init__impl__6a9atx(41)).toString();
      }
      r4e() {
        return this.k4e_1;
      }
    }
    initMetadataForClass($, 'ByteString', VOID, VOID, [Comparable()]);
    ByteStringClass = $;
  }
  return ByteStringClass;
}
function ByteString_0(bytes) {
  var tmp;
  // Inline function 'kotlin.collections.isEmpty' call
  if (bytes.length === 0) {
    tmp = Companion_getInstance().i4e_1;
  } else {
    tmp = Companion_getInstance().n4e(bytes);
  }
  return tmp;
}
function decodeToString_0(_this__u8e3s4) {
  return decodeToString(_this__u8e3s4.r4e());
}
function isEmpty(_this__u8e3s4) {
  return _this__u8e3s4.v2() === 0;
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstance1n5a3xz7n277t,
  ByteString_0 as ByteString3c9fk8lsh3lvs,
  ByteString as ByteString10sanmoo66key,
  decodeToString_0 as decodeToString2ede220pr5xir,
};
//endregion

//# sourceMappingURL=ByteString.mjs.map
